import React from 'react';
import LeadGenerationButton from '@components/LeadGenerationForm/LeadGenerationButton';
import { LEAD_GEN_PROMO_TOP_STRIP } from '@src/constants/LeadGenerationConstants/index';

// Same fixed-strip contract as the default PlacementReportTopStrip
// (h-[44px]/md:h-[40px], bg-v5-green-100) so swapping it in for this one page
// doesn't shift the fixed nav height that Hero's own top padding is
// calibrated against.
const AiEngineeringPromoTopStrip = () => {
  return (
    <div className="flex h-[44px] w-[100dvw] items-center justify-center border-b-[1px] border-white bg-v5-green-100 px-6 text-center text-sm sm:text-base md:h-[40px]">
      <span className="font-rubik text-black">
        Transform your career with Crio.Do | Grab scholarships worth{' '}
        <b className="font-extrabold">₹1,00,000</b> |{' '}
        <LeadGenerationButton
          wrapperClassName="inline-block cursor-pointer"
          buttonComponent={
            <strong className="font-bold underline">Apply Now</strong>
          }
          buttonLocation={LEAD_GEN_PROMO_TOP_STRIP}
        />
      </span>
    </div>
  );
};

export default AiEngineeringPromoTopStrip;
